import { render, staticRenderFns } from "./show-pdf.vue?vue&type=template&id=77b00477&scoped=true"
import script from "./show-pdf.vue?vue&type=script&lang=js"
export * from "./show-pdf.vue?vue&type=script&lang=js"
import style0 from "./show-pdf.vue?vue&type=style&index=0&id=77b00477&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77b00477",
  null
  
)

export default component.exports